import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles({
  card: {
    minHeight: "100%",
    width: "290px",
    position: "relative",
    borderRadius: "12px",
    display: "flex",
    flexDirection: "column",
    boxShadow: "0px 8px 24px -4px rgba(24, 39, 75, 0.08), 0px 6px 12px -6px rgba(24, 39, 75, 0.12)",
    "&:focus-within": {
      outline: "2px solid #00338D",
    },
  },
  media: {
    height: "196px",
    width: "100%",
  },
  cardActionArea: {
    display: "flex !important",
    flexDirection: "column",
    flexGrow: 1,
  },
  content: {
    paddingBottom: 0,
    overflow: "hidden",
    display: "-webkit-box",
    WebkitBoxOrient: "vertical",
    WebkitLineClamp: 5,
    textOverflow: "ellipsis",
  },
  contentWrapper: {
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
    width: "100%",
  },
  contentHeader: {
    fontSize: "16px",
    fontWeight: 700,
    lineHeight: "24px",
    textAlign: "left",
  },
  contentDescription: {
    fontSize: "12px",
    fontWeight: 400,
    lineHeight: "24px",
    letterSpacing: "-0.01em",
  },
  contentId: {
    fontSize: "10px",
    padding: "5px 0",
    color: "#757575",
  },
  tagsContainer: {
    margin: "10px 10px 10px 16px",
  },
  tags: {
    display: "inline-block",
    padding: "8px 4px",
    border: "1px solid",
    borderRadius: "4px",
    marginRight: "5px",
    marginTop: "10px",
  },
});
